import checkIsAdultPassengerType from './checkIsAdultPassengerType';

/**
 * Returns a human-readable change policy label for a flight fare.
 * Derives the label purely from data (amounts and isExchangeAble flag),
 * @param {object} fare - fare object
 * @param {string} currencySign - currency symbol, defaults to '$'
 * @returns {string|null}
 */
const getChangePolicyLabel = (fare, currencySign = '$') => {
  if (!fare) return null;

  const beforePolicy = fare.exchangePolicy?.beforeDeparture;
  if (beforePolicy?.isExchangeAble === false) return 'Non-changeable';

  const beforeAmount = beforePolicy?.amount;
  if (beforeAmount != null && beforeAmount > 0) return `${currencySign}${beforeAmount} change fee`;

  const adultPolicy = fare.exchangePolicyByPassengerTypes?.find((p) =>
    checkIsAdultPassengerType(p),
  );
  if (adultPolicy?.beforeDeparture?.isExchangeAble === false) return 'Non-changeable';

  const adultFeeAmount = adultPolicy?.beforeDeparture?.amount;
  if (adultFeeAmount != null && adultFeeAmount > 0)
    return `${currencySign}${adultFeeAmount} change fee`;

  const isExchangeAble = beforePolicy?.isExchangeAble;
  if (isExchangeAble === true) return 'Changeable (fees may apply)';

  return null;
};

export default getChangePolicyLabel;
